import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";

import { storeState } from "@/comn/features/recoil";
import { Icon } from "@/comn/components";

import { useBookmark } from "../../../config/BookmarkConfig";
import { useMenu } from "../../../config/MenuConfig";
import { defaultStoreState } from "../../../recoil/storeState";

export const NavigationTabBookmark = () => {
    const { root } = useMenu();
    const { bookmark, removeBookmark } = useBookmark();
    const setStore = useSetRecoilState(storeState);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const menuIds = bookmark.map(({ menuId }: any) => menuId);

    let data: any[] = [];
    if (Array.isArray(root?.children)) {
        const _ = (ary: any) => {
            for (const item of ary) {
                if (menuIds.includes(item.menuId)) {
                    data.push(item);
                }
                if (Array.isArray(item.children)) {
                    _(item.children);
                }
            }
        };
        _(root.children);
    }

    const handleClickItem = (menuUrlAddr: any) => {
        if (menuUrlAddr) {
            if (process.env.REACT_APP_BASE === menuUrlAddr.slice(0, 5)) {
                setStore(defaultStoreState);
                navigate(`${menuUrlAddr}`);
            } else {
                const origin = window.location.origin;
                window.location.href = origin + menuUrlAddr;
            }
        }
    };

    const handleClickBookmark = async (menuId: any) => {
        if (!isLoading) {
            setIsLoading(true);

            await removeBookmark(menuId);

            setIsLoading(false);
        }
    };

    return (
        <ul className="flex flex-col px-4">
            {data.map(({ menuId, menuNm, menuUrlAddr }) => {
                return (
                    <li key={`bookmark - ${menuNm}`} className="flex items-center justify-between gap-2">
                        <button
                            onClick={() => handleClickItem(menuUrlAddr)}
                            className="p-2 min-h-[2.5rem] flex-1 text-lg text-left rounded text-gray dark:text-lightgray hover:bg-gray/10 dark:hover:bg-white/5"
                        >
                            {menuNm}
                        </button>
                        <button onClick={() => handleClickBookmark(menuId)}>
                            <Icon className="text-primary" icon="star_fill" size="sm" />
                        </button>
                    </li>
                );
            })}
        </ul>
    );
};
